import React, { useEffect } from 'react'
import Pdf from 'react-to-pdf'

const GeneratePDF = () => {
  const ref = React.createRef()

  useEffect(() => {
    console.log(window.my_special_setting)
  }, [])

  return (
    <div className="App">
      <Pdf targetRef={ref} filename="code-example.pdf">
        {({ toPdf }) => <button onClick={toPdf}>Generate Pdf</button>}
      </Pdf>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 842,
          height: 1150,
        }}
        ref={ref}
      >
        <h1>Hello CodeSandbox</h1>
        <h2>Start editing to see some magic happen!</h2>
      </div>
    </div>
  )
}

export default GeneratePDF
